import Vue from 'vue'
import Router from 'vue-router'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _2af77c4c = () => interopDefault(import('../pages/help.vue' /* webpackChunkName: "pages/help" */))
const _29e42c4a = () => interopDefault(import('../pages/recover.vue' /* webpackChunkName: "pages/recover" */))
const _29a42bee = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: decodeURI('/'),
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/help",
    component: _2af77c4c,
    name: "help"
  }, {
    path: "/recover",
    component: _29e42c4a,
    name: "recover"
  }, {
    path: "/",
    component: _29a42bee,
    name: "index"
  }],

  fallback: false
}

export function createRouter () {
  return new Router(routerOptions)
}
